import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IResourceInspection } from "../domain/IResourceInspection";
import { DailyTableService } from "../services/dt.service";

interface dtRegistrationState {
  loading: boolean;
  resourcesInspections: IResourceInspection[];
  error: any;
}

const initialState: dtRegistrationState = {
  loading: false,
  resourcesInspections: [],
  error: undefined,
};

export const getBasicDataForInspectionsOfResources = createAsyncThunk(
  "DailyTable/getBasicDataForInspectionsOfResources",
  async () => {
    try {
      const result =
        await DailyTableService.getBasicDataForInspectionsOfResources();
      return result.resourcesInspections;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtRegistrationSlice = createSlice({
  name: "Registrations",
  initialState: initialState,
  reducers: {
    setRegistrations: (state, action: PayloadAction<IResourceInspection[]>) => {
      state.resourcesInspections = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBasicDataForInspectionsOfResources.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getBasicDataForInspectionsOfResources.fulfilled,
      (state, action) => {
        state.resourcesInspections = action.payload ? action.payload : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getBasicDataForInspectionsOfResources.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) =>
  state.dailytable.resourcesInspections;

export const { setError } = dtRegistrationSlice.actions;

export default dtRegistrationSlice.reducer;
